var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('router-view',{attrs:{"cfg":_vm.get_cfg}}),_c('div',{staticStyle:{"position":"fixed","bottom":"10px","left":"10px"}},[(!_vm.$store.state.G.PRODUCTION)?_c('h1',{staticStyle:{"color":"red"}},[_vm._v("ESTA VERSIÓN ES SÓLO PARA PRUEBAS")]):_vm._e(),_vm._v(" ABAKAN sistemas ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }